import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SaveWithoutContactsPopupComponent } from './save-without-contacts-popup.component';

export type SaveWithoutContactsPopupResult = 'Confirmed';

export interface SaveWithoutContactsPopupData {
  organisationName: string;
}

const SAVE_WITHOUT_CONTACTS_DIALOG_CHROME = {
  panelClass: 'save-without-contacts-popup-panel',
  backdropClass: 'save-without-contacts-popup-backdrop'
};

export function openSaveWithoutContactsPopup(
  matDialog: MatDialog,
  data: SaveWithoutContactsPopupData
): MatDialogRef<SaveWithoutContactsPopupComponent, SaveWithoutContactsPopupResult> {
  return matDialog.open<
    SaveWithoutContactsPopupComponent,
    SaveWithoutContactsPopupData,
    SaveWithoutContactsPopupResult
  >(SaveWithoutContactsPopupComponent, { data, ...SAVE_WITHOUT_CONTACTS_DIALOG_CHROME });
}
